<template>
    <div>
        <the-header>
            <template v-slot:title>
                {{ $route.meta.title }}
            </template>
        </the-header>
        <section class="section">
            <div class="container scanner-view">
                <the-barcode-scanner
                    :inline="true"
                    :auto-stop="true"
                    @detected="onDetected"
                    @error="onScannerError"
                    ref="scanner"
                />
            </div>
        </section>
    </div>
</template>

<script>
import TheHeader from '@/components/TheHeader'
import TheBarcodeScanner from '@/components/TheBarcodeScanner'

export default {
    name: 'Scanner',
    components: {
        'the-header': TheHeader,
        'the-barcode-scanner': TheBarcodeScanner
    },
    metaInfo: {
        title: 'Skaner kodów'
    },
    methods: {
        onDetected(barcode) {
            this.$store.dispatch('setCodeSearchQuery', barcode.rawValue)
            this.$store.dispatch('searchByCode', barcode.rawValue)
            this.$store.dispatch('addNotification', {
                type: 'success',
                title: 'Kod zeskanowany',
                content: 'Wykryto kod: ' + barcode.rawValue
            })
            this.$router.push('/deliveries')
        },
        onScannerError(error) {
            this.$store.dispatch('addNotification', {
                type: 'warning',
                title: 'Błąd skanera',
                content: error
            })
        }
    },
    mounted() {
        var self = this
        this.$nextTick(function () {
            if (self.$refs.scanner) {
                self.$refs.scanner.startScanning()
            }
        })
    }
}
</script>

<style lang="sass" scoped>
.scanner-view
    display: flex
    justify-content: center
</style>
